const ZoomInIcon = () => {
    return (
        <img
            style={{ width: '100%', height: '100%' }}
            src="/images/zoom-in-icon.svg"
            alt="Document Icon"
        />
    );
};

export default ZoomInIcon;
